import { Routes, Route, Navigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'
import PublicLayout from '@/components/layout/PublicLayout'
import AppLayout from '@/components/layout/AppLayout'
import LoginPage from '@/pages/LoginPage'
import PublicDashboardPage from '@/pages/PublicDashboardPage'
import AdminDashboardPage from '@/pages/AdminDashboardPage'
import StadionDashboardPage from '@/pages/stadion/StadionDashboardPage'
import KegiatanDetailPage from '@/pages/kegiatan/KegiatanDetailPage'
import KegiatanFormPage from '@/pages/kegiatan/KegiatanFormPage'
import PesertaFormPage from '@/pages/kegiatan/PesertaFormPage'
import PresensiPage from '@/pages/presensi/PresensiPage'
import PesertaDetailPage from '@/pages/presensi/PesertaDetailPage'
import LaporanListPage from '@/pages/laporan/LaporanListPage'
import LaporanFormPage from '@/pages/laporan/LaporanFormPage'
import LaporanViewerPage from '@/pages/laporan/LaporanViewerPage'
import PimpinanPage from '@/pages/pimpinan/PimpinanPage'
import ProgramKerjaPage from '@/pages/program/ProgramKerjaPage'
import SettingsPage from '@/pages/SettingsPage'
import RapatFormPage from '@/pages/rapat/RapatFormPage'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    useAuthStore.getState().initialize()
    setReady(true)
  }, [])

  if (!ready) return null
  if (!isAuthenticated) return <Navigate to="/login" replace />
  return <>{children}</>
}

function SuperAdminRoute({ children }: { children: React.ReactNode }) {
  const role = useAuthStore((s) => s.role)
  if (role !== 'super_admin') return <Navigate to="/admin/dashboard" replace />
  return <>{children}</>
}

export default function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<PublicDashboardPage />} />
        <Route path="/dashboard" element={<PublicDashboardPage />} />
        <Route path="/kegiatan/:id" element={<KegiatanDetailPage />} />
        <Route path="/laporan/viewer/:id" element={<LaporanViewerPage />} />
      </Route>

      {/* Login */}
      <Route path="/login" element={<LoginPage />} />

      {/* Admin Routes - Protected */}
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
        <Route path="/admin/stadion" element={<StadionDashboardPage />} />
        <Route
          path="/admin/kegiatan/new"
          element={
            <SuperAdminRoute>
              <KegiatanFormPage />
            </SuperAdminRoute>
          }
        />
        <Route
          path="/admin/kegiatan/:id/edit"
          element={
            <SuperAdminRoute>
              <KegiatanFormPage />
            </SuperAdminRoute>
          }
        />
        <Route path="/admin/kegiatan/:id/peserta/new" element={<PesertaFormPage />} />
        <Route path="/admin/kegiatan/:id/presensi" element={<PresensiPage />} />
        <Route path="/admin/kegiatan/:id/peserta/:pesertaId" element={<PesertaDetailPage />} />
        <Route path="/admin/kegiatan/:id/rapat/new" element={<RapatFormPage />} />
        <Route path="/admin/kegiatan/:id/rapat/:rapatId" element={<RapatFormPage />} />
        <Route path="/admin/laporan" element={<LaporanListPage />} />
        <Route path="/admin/laporan/new" element={<LaporanFormPage />} />
        <Route path="/admin/laporan/:id" element={<LaporanFormPage />} />
        <Route
          path="/admin/pimpinan"
          element={
            <SuperAdminRoute>
              <PimpinanPage />
            </SuperAdminRoute>
          }
        />
        <Route path="/admin/program-kerja" element={<ProgramKerjaPage />} />
        <Route path="/admin/settings" element={<SettingsPage />} />
      </Route>

      {/* Fallback - redirect to public dashboard */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
